<template>
  <el-dialog
    :title="$t('SmartLocker.ContractExpireDialog.ExpiredTitle')"
    :visible.sync="isDialogVisible"
    :close-on-press-escape="false"
    :show-close="false"
    :close-on-click-modal="false"
    class="contract-expire-dialog"
  >
    <div class="contract-expire-dialog__content">
      <span class="contract-expire-dialog__icon">
        <i aria-hidden="true" class="icon-smart-locker"></i>
      </span>
      <p class="contract-expire-dialog__main">
        {{ $t('SmartLocker.ContractExpireDialog.Description') }}
      </p>
      <p class="contract-expire-dialog__hint">
        {{ $t('SmartLocker.ContractExpireDialog.Instruction') }}
      </p>
      <p class="contract-expire-dialog__expire">
        {{ $t('SmartLocker.ContractExpireDialog.ExpiredAt', { date: displayExpireDate }) }}
      </p>
    </div>
    <template #footer>
      <el-button
        type="primary"
        round
        class="contract-expire-dialog__confirm"
        @click="handleConfirm"
      >
        {{ $t('SmartLocker.ContractExpireDialog.Confirm') }}
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  name: 'ContractExpireDialog',
  computed: {
    ...mapState({
      isContractDialogVisible: (state) => state.smartLocker.isContractDialogVisible,
      hasNextContract: (state) => state.smartLocker.hasNextContract
    }),
    ...mapGetters('smartLocker', ['displayExpireDate']),
    isDialogVisible: {
      get () {
        return this.isContractDialogVisible
      },
      set (value) {
        this.setContractDialogVisible(value)
      }
    }
  },
  methods: {
    ...mapMutations('smartLocker', [
      'setContractDialogVisible',
      'setContractAlertBannerShow'
    ]),
    handleConfirm () {
      this.setContractDialogVisible(false)
      if (!this.hasNextContract) {
        this.setContractAlertBannerShow(true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.contract-expire-dialog {
  ::v-deep .el-dialog {
    @include basicDialog;
    min-width: 480px;
    width: 480px;
    .el-dialog__header {
      padding: 18px 24px;
    }
    .el-dialog__title {
      color: $fontColor;
      font-size: map-get($fontSize, xx-large);
      font-weight: 600;
    }
    .el-dialog__body {
      overflow-y: unset;
      padding-top: 32px;
    }
    .el-dialog__footer {
      border-top: unset;
      text-align: center;
      padding-top: 0;
    }
    .el-button span {
      vertical-align: baseline;
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;

    & i {
      font-size: 70px;
      color:$mainColor;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__main {
    font-size: map-get($fontSize, large);
    color: $fontColor;
    margin-bottom: 20px;
  }

  &__hint {
    font-size: map-get($fontSize, medium);
    color: $fontColor;
    margin-bottom: 8px;
  }

  &__expire {
    font-size: map-get($fontSize, medium);
    color: $warnColor;
    font-weight: 600;
  }

  &__confirm {
    min-width: 125px;
    font-weight: 600;
  }
}
</style>
